// Single source of truth for the order-status vocabulary (Spec 048).
// Maps every status to a human label + a badge colour class.
const STATUS_META: Record<string, { label: string; cls: string }> = {
  CREATED: { label: 'Created', cls: 'pending' },
  PICKUP_ASSIGNED: { label: 'Pickup assigned', cls: 'order-info' },
  IN_PROGRESS: { label: 'In progress', cls: 'order-info' },
  SERVICE_COMPLETE: { label: 'Service complete', cls: 'order-teal' },
  DROPOFF_ASSIGNED: { label: 'Drop-off assigned', cls: 'order-info' },
  COMPLETED: { label: 'Completed', cls: 'approved' },
  DISPUTED: { label: 'Disputed', cls: 'rejected' },
  CANCELLED: { label: 'Cancelled', cls: 'rejected' },
  ADMIN_CLOSED: { label: 'Admin closed', cls: 'order-neutral' },
  SETTLED: { label: 'Settled', cls: 'approved' },
  // Legacy values that may appear on old rows.
  APPROVED: { label: 'Approved', cls: 'approved' },
  PICKUP_SCHEDULED: { label: 'Pickup scheduled', cls: 'pending' },
  CAR_PICKED_UP: { label: 'Car picked up', cls: 'pending' },
  CAR_DELIVERED_TO_GARAGE: { label: 'Delivered to garage', cls: 'pending' },
  IN_SERVICE: { label: 'In service', cls: 'order-info' },
  CAR_RETURNED: { label: 'Car returned', cls: 'approved' },
  REFUNDED: { label: 'Refunded', cls: 'rejected' },
};

export function orderStatusLabel(status: string): string {
  return STATUS_META[status]?.label ?? status.replace(/_/g, ' ');
}

export default function OrderStatusBadge({ status }: { status: string }) {
  const meta = STATUS_META[status] ?? { label: status.replace(/_/g, ' '), cls: 'pending' };
  return <span className={`admin-badge ${meta.cls}`}>{meta.label}</span>;
}
